/* Echoa — Kassenbild nachtragen (01.10.2026, Runde 2 nach code-pruefer)

   🔴 WOZU: Die Shopify-Kasse zeigt für eine Zeile mit eigenem Andruck das Bild
   aus der Property `_kassen_bild` (Cart-Transform-Funktion `andruck-bild`).
   Dieses Bild MUSS auf cdn.shopify.com liegen — eine andere Domain lehnt die
   Kasse ab (`invalid_image_url`, gemessen 01.10.2026). Das Backend übernimmt
   unser gerahmtes Vorschaubild (`_vorschau_url`) in die Dateiablage des Shops
   (`POST /api/kassenbild`); dieses Skript holt die Adresse ab und trägt sie an
   der Zeile nach.

   ⚠️ LATENZ: Shopify braucht 3,5–11,4 s pro Bild (n=3). Die Produktseite stößt
   das Hochladen schon beim „In den Warenkorb" an; das Backend antwortet sofort
   (202 „läuft" oder 200 mit Adresse) und lädt je Bild genau EINMAL hoch. Hier
   wird nur nachgefragt. Nichts davon blockiert den Kunden: wer schneller an
   der Kasse ist, sieht dort das Variantenbild.

   TAKT_MS / FRIST_MS: JA für Shopifys Verarbeitung (gemessen bis 11,4 s, die
   Frist lässt das Vierfache); NEIN als Zeitlimit für den Kunden. Jede Nachfrage
   ist ein kurzer Aufruf (< 1 s, kein neuer Upload). MAX_FEHLER: JA für
   transiente 5xx/Netz; ein 4xx bricht sofort ab.

   🔴 MENGE UND PROPERTIES FRISCH LESEN (Runde 1): zwischen Abholen und
   Nachtragen können Sekunden liegen, in denen der Kunde die Menge ändert.
   Deshalb wird die Zeile direkt vor `cart/change.js` neu aus /cart.js geholt —
   `change.js` mit `properties` ERSETZT alle Properties und setzt die Menge,
   beides muss der aktuelle Stand sein. Fehlt die Zeile inzwischen, nichts tun.
   Kein Neuladen der Seite: Dawns Warenkorb adressiert Zeilen über ihre
   Position, nicht über den Schlüssel, der sich hier ändert. */
(function () {
  'use strict';
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const TAKT_MS = 1500;
  const FRIST_MS = 45000;
  const MAX_FEHLER = 3;
  const CDN = /^https:\/\/cdn\.(shopify\.com|shopifycdn\.net)\//;
  const warte = (ms) => new Promise((ok) => setTimeout(ok, ms));

  async function kassenbildHolen(vorschau) {
    const basis = new URL(vorschau).origin;
    const ende = Date.now() + FRIST_MS;
    let fehler = 0;
    while (Date.now() < ende) {
      try {
        /* text/plain: „einfache" Anfrage, kein CORS-Vorabruf — das Backend
           liest den Rumpf ohnehin als JSON. */
        const r = await fetch(`${basis}/api/kassenbild`, {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
          body: JSON.stringify({ url: vorschau }),
        });
        if (r.status === 200) {
          const d = await r.json();
          return d && typeof d.url === 'string' && CDN.test(d.url) ? d.url : null;
        }
        if (r.status !== 202) {
          if (r.status < 500) return null;           // 400/404/429: nicht weiter
          fehler += 1;
        }
      } catch (e) { fehler += 1; }
      if (fehler >= MAX_FEHLER) return null;
      await warte(TAKT_MS);
    }
    return null;
  }

  async function korb() {
    return fetch(`${root}cart.js`).then((r) => r.json());
  }

  async function nachtragen() {
    let start;
    try { start = await korb(); } catch (e) { return; }
    for (const zeile of start.items || []) {
      const p0 = zeile.properties || {};
      if (!p0._vorschau_url || p0._kassen_bild) continue;
      let vorschau;
      try { vorschau = new URL(p0._vorschau_url).toString(); } catch (e) { continue; }
      const cdn = await kassenbildHolen(vorschau);
      if (!cdn) continue;
      try {
        const jetzt = (await korb()).items.find((z) => z.key === zeile.key);
        if (!jetzt || (jetzt.properties || {})._kassen_bild) continue;
        await fetch(`${root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: jetzt.key, quantity: jetzt.quantity,
            properties: Object.assign({}, jetzt.properties, { _kassen_bild: cdn }) }),
        });
      } catch (e) { /* Kasse zeigt dann das Variantenbild */ }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', nachtragen);
  } else {
    nachtragen();
  }
})();
